/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PayoutListItemResponse = {
    id: string;
    payoutNumber: string;
    expert: Record<string, any>;
    payoutMonth: string;
    totalEarnings: string;
    platformCommission: string;
    totalDeductions: string;
    disputesCount: number;
    disputesAmount: string;
    netPayout: string;
    status: string;
    holdReason?: Record<string, any>;
    /**
     * Date until which the payout is held
     */
    holdUntil?: Record<string, any>;
    releasedBy?: Record<string, any>;
    createdAt: string;
    /**
     * When funds reached the expert bank account
     */
    bankSettledAt?: Record<string, any>;
    /**
     * Reason if bank payout failed
     */
    bankFailureReason?: Record<string, any>;
    /**
     * Which payout rail this row runs on
     */
    payoutMethod: PayoutListItemResponse.payoutMethod;
    /**
     * Bank transfer reference (manual rail only)
     */
    bankReferenceNumber?: Record<string, any>;
};
export namespace PayoutListItemResponse {
    /**
     * Which payout rail this row runs on
     */
    export enum payoutMethod {
        STRIPE_CONNECT = 'stripe_connect',
        MANUAL_BANK = 'manual_bank',
    }
}

